import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { LinkProps } from 'react-router-dom';
import Button from '../../../Components/Button/Button';
import React, { useRef, useEffect, useMemo } from 'react';
import ImageContainer from '../../../Components/ImageContainers/ImageContainer';

const IntroSection: React.FC = () => {
  const copyOne: string =
    'Take technology.<br/>Add marketing nous,<br/>creativity and a healthy<br/>dose of entrepreneurial spirit.<br/>Take away smoke, mirrors<br/>and arrogance.';
  const ctaOneCopy: string = 'How can we help?';
  const ctaOneType: 'internal' | 'external' | 'function' | 'none' = 'external';
  const ctaOneLink: string | LinkProps['to'] = `/how-can-we-help/`;
  const backgroundImageOne: any = './images/introSection_1.webp';
  const backgroundImageTwo: any = './images/introSection_3.webp';

  const introSectionRef: React.MutableRefObject<any> = useRef(null);

  const imageOne: JSX.Element = useMemo(() => {
    return <ImageContainer data={{ imageSource: backgroundImageOne, imageIsLazy: true }} />;
  }, []);
  const imageTwo: JSX.Element = useMemo(() => {
    return <ImageContainer data={{ imageSource: backgroundImageTwo, imageIsLazy: true }} />;
  }, []);

  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);

    var textAnimationFour = gsap.to('.textSectionFour', {
      opacity: 1,
      y: 0,
      ease: 'none',
      scrollTrigger: {
        trigger: '.topSection',
        start: '0px 900px',
        end: '0px',
        scrub: 0,
      },
    });

    var imageAnimationOne = gsap.to('.backgroundImageOne', {
      opacity: 0.3,
      ease: 'none',
      scrollTrigger: {
        trigger: '.topSection',
        start: '000px 100px',
        end: '400px',
        scrub: 0.5,
      },
    });

    return () => {
      textAnimationFour.kill();
      imageAnimationOne.kill();
    };
  }, []);

  return (
    <section ref={introSectionRef} className="IntroSection">
      <div className="inner">
        <div className="topSection">
          <div className="inner">
            <div className="backgroundImage backgroundImageOne">
              <div className="inner" data-speed="1.4" data-lag="0">
                {imageOne}
              </div>
            </div>

            <div className="contentContainer">
              <div className="inner">
                <div data-speed="1" data-lag="0.3">
                  <h1>
                    <Button
                      data={{
                        buttonHasTilt: true,
                        buttonShowTiltOn: 'always',
                        buttonTiltColor: '#13121C',
                        buttonTiltMaxRotation: 4,
                        buttonTiltMaxSkew: 4,
                        buttonCustomClass: 'clrMustard font-h1',
                        buttonLinkType: 'none',
                        buttonContent: 'Add',
                      }}
                    />
                    <span className="boldMe">
                      {' '}
                      the strategic and creative fire-power of an advertising agency, to the precision and rigour of a
                      digital marketing agency, and watch the value of your business soar.
                    </span>
                    <span style={{ height: '30px', display: 'block' }}></span>
                  </h1>

                  <span className="textSectionFour">

                    {/* <Button
                      data={{
                        buttonHasTilt: true,
                        buttonShowTiltOn: 'always',
                        buttonTiltColor: '#13121C',
                        buttonTiltMaxRotation: 2,
                        buttonTiltMaxSkew: 2,
                        buttonCustomClass: 'clrMustard font-h1 ',
                        buttonLinkType: 'none',
                        buttonLinkHref: '/contact',
                        buttonLinkFunction: () => {},
                        buttonContent: "Let's chat",
                        buttonIcon: '',
                      }}
                    /> */}

<div className="Button"><div className="inner"><div className="TiltContainer" style={{ backgroundColor: '#13121C', transform: 'rotate(0deg) skewX(0deg)' }}></div><a href="/how-can-we-help/" className="clrMustard" target="_self" rel="noreferrer"> Tell us your story</a></div></div>

                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="largeSpacer"></div>

        <div className="bottomSection">
          <div className="inner">
            <div className="backgroundImage">
              <div className="inner" data-speed="1.2" data-lag="0">
                {/* <AnimationWrapper> */}
                {imageTwo}
                {/* </AnimationWrapper> */}
              </div>
            </div>

            <div className="contentContainer">
              <div className="inner">
                <p className="p-large" dangerouslySetInnerHTML={{ __html: copyOne }} />

                <Button
                  data={{
                    buttonHasTilt: true,
                    buttonShowTiltOn: 'always',
                    buttonTiltColor: '#13121C',
                    buttonTiltMaxRotation: 2,
                    buttonTiltMaxSkew: 2,
                    buttonCustomClass: 'clrMustard',
                    buttonLinkType: ctaOneType,
                    buttonLinkHref: ctaOneLink,
                    buttonContent: ctaOneCopy,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntroSection;
